
const parseCoordinate = (text, size) => {
  let match
  match = text.match(/^([0-9]+(\.[0-9]+)?)%$/)
  if (match) return parseFloat(match[1])
  match = text.match(/^([0-9]+(\.[0-9]+)?)px$/)
  if (match) return parseFloat(match[1]) * 100 / size
  return null
}

const createShape = (clipPath, width, height) => {
  const shape = {
    width,
    height,
    hopX: 3 * 100 / width,
    hopY: 3 * 100 / height,
    verteces: [] 
  }
  const match = clipPath.match(/^\s*polygon\((.+)\)\s*$/)
  if (!match) return shape
  const vertexList = match[1]
    .split(',')
    .map(coordinates => {
      const parts = coordinates.trim().split(' ')
      if (parts.length !== 2) return null
      return { 
        x: parseCoordinate(parts[0].trim(), width),
        y: parseCoordinate(parts[1].trim(), height)
      }

    })
  if (vertexList.find(position => (!position || position.x === null) || (position.y === null))) return shape
  shape.verteces = vertexList
  updateClipPath(shape)
  return shape
}

const updateClipPath = (shape) => {
  const values = shape.verteces.map(vertex => `${vertex.x}% ${vertex.y}%`).join(', ')
  shape.clipPath = `polygon(${values})`
}

const makeVertexClipPath = (x, y) => {
  return `circle(2px at ${x}% ${y}%)`
}

const moveVertex = (shape, index, x, y) => {
  shape.verteces[index].x = (x * 100 / shape.width + 50)
  shape.verteces[index].y = (y * 100 / shape.height + 50)
  updateClipPath(shape)
  return shape.verteces[index]
}

const translateShape = (shape, x, y) => {
  shape.verteces.forEach(vertex => {
    vertex.x = vertex.x + (x * 100 / shape.width)
    vertex.y = vertex.y + (y * 100 / shape.height)
  })
  updateClipPath(shape)
  return shape
}

const addVertex = ( clipPath ) => {
  const newClipPath =  createShape(clipPath)
  newClipPath.verteces.push({x: newClipPath.verteces[0].x + 2, y: newClipPath.verteces[0].y + 2})
  updateClipPath(newClipPath)
  return newClipPath.clipPath
}

const deleteVertex = ( clipPath ) => {
  const newClipPath =  createShape(clipPath)
  newClipPath.verteces.pop()
  updateClipPath(newClipPath)
  return newClipPath.clipPath
}

export { addVertex, createShape, deleteVertex, makeVertexClipPath, moveVertex, translateShape }